import React from 'react';
import { useNavigate } from 'react-router-dom';
import bestLogo from '../assets/logo-best.jpeg';
import './LandingPage.css';

const productStats = [
  { label: 'Kehadiran', value: '84%', tone: 'green' },
  { label: 'Peranan', value: '4', tone: 'gold' },
  { label: 'Sesi', value: '10', tone: 'blue' },
];

const workflowItems = [
  'Refleksi guru berstruktur',
  'Analisis kehadiran pentadbir',
  'Jadual ikut sekolah dan terminal',
];

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <main className="landing-shell">
      <header className="landing-nav">
        <button type="button" className="landing-brand" onClick={() => navigate('/')}>
          <span className="landing-brand-mark">
            <img src={bestLogo} alt="Logo BEST BTOP" />
          </span>
          <span>
            <strong>BTOP Wellness</strong>
            <small>Program BEST 2.0</small>
          </span>
        </button>

        <nav className="landing-actions" aria-label="Navigasi utama">
          <button type="button" className="landing-link" onClick={() => navigate('/login')}>
            Log Masuk
          </button>
          <button type="button" className="landing-primary" onClick={() => navigate('/signup')}>
            Daftar Akaun
          </button>
        </nav>
      </header>

      <section className="landing-hero">
        <div className="landing-copy">
          <h1>BEST 2.0</h1>
          <p>
            Portal bersepadu untuk pelajar, guru, jurulatih dan pentadbir memantau jadual,
            kehadiran, refleksi kelas dan perkembangan program dengan lebih teratur.
          </p>

          <div className="landing-cta-row">
            <button type="button" className="landing-primary landing-primary-large" onClick={() => navigate('/signup')}>
              Daftar Akaun
            </button>
            <button type="button" className="landing-secondary" onClick={() => navigate('/login')}>
              Saya sudah ada akaun
            </button>
          </div>

          <div className="landing-proof" aria-label="Fungsi utama portal">
            {workflowItems.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>

        <div className="product-stage" aria-label="Pratonton papan pemuka">
          <div className="product-browser">
            <div className="product-browser-bar">
              <span />
              <span />
              <span />
            </div>

            <div className="product-dashboard">
              <aside className="product-sidebar">
                <div className="product-logo">
                  <img src={bestLogo} alt="" />
                </div>
                <div className="product-menu active">Utama</div>
                <div className="product-menu">Kehadiran</div>
                <div className="product-menu">Jadual</div>
                <div className="product-menu">Maklum Balas</div>
              </aside>

              <section className="product-main">
                <div className="product-topline">
                  <div>
                    <span>Papan Pemuka Pentadbir</span>
                    <strong>Kehadiran ikut sesi</strong>
                  </div>
                  <button type="button">Eksport CSV</button>
                </div>

                <div className="product-stat-grid">
                  {productStats.map((stat) => (
                    <div key={stat.label} className={`product-stat ${stat.tone}`}>
                      <span>{stat.label}</span>
                      <strong>{stat.value}</strong>
                    </div>
                  ))}
                </div>

                <div className="product-content-grid">
                  <div className="product-chart">
                    <div className="chart-head">
                      <span>Kehadiran Mingguan</span>
                      <strong>Data diselaraskan</strong>
                    </div>
                    <div className="chart-bars">
                      <i style={{ '--bar': '62%' }} />
                      <i style={{ '--bar': '74%' }} />
                      <i style={{ '--bar': '58%' }} />
                      <i style={{ '--bar': '84%' }} />
                      <i style={{ '--bar': '78%' }} />
                    </div>
                  </div>

                  <div className="product-session">
                    <span>Sesi Seterusnya</span>
                    <strong>Bahasa Inggeris</strong>
                    <p>Sabtu, 9:00 pagi - Terminal 2</p>
                    <div className="session-progress">
                      <span />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div className="floating-card floating-card-b">
            <span>Refleksi Guru</span>
            <strong>Catatan kelas tersusun</strong>
          </div>
        </div>
      </section>

      <section className="landing-strip" aria-label="Modul program">
        <div>
          <span>Pelajar</span>
          <strong>Jadual dan rekod kehadiran sendiri.</strong>
        </div>
        <div>
          <span>Cikgu</span>
          <strong>Maklum balas kelas dan kehadiran subjek.</strong>
        </div>
        <div>
          <span>Pentadbir</span>
          <strong>Pantau peratus kehadiran ikut sesi.</strong>
        </div>
      </section>
    </main>
  );
};

export default LandingPage;
